module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/babel-runtime/core-js/object/create.js
// module id = 482
// module chunks = 0 1